/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Grid, Image, Label } from '@mairistem/composants';

interface ModalGestionTrimestreRowProps {
  content: React.ReactNode;
  actions: React.ReactNode;
  icon: string;
}

const ModalGestionTrimestreRow = (props: ModalGestionTrimestreRowProps) => {
  const { content, actions, icon } = props;

  return (
    <Grid.Row verticalAlign="middle" style={{ backgroundColor: 'lightgrey' }}>
      <Grid.Column width={2}>
        <Label ribbon color="blue">
          <Image
            inline
            src={icon}
            style={{
              height: 40,
              objectFit: 'scale-down',
            }}
          />
        </Label>
      </Grid.Column>
      <Grid.Column width={11}>{content}</Grid.Column>
      <Grid.Column width={3} style={{ display: 'flex', gap: '.5em' }}>
        {actions}
      </Grid.Column>
    </Grid.Row>
  );
};

export default ModalGestionTrimestreRow;
